module.exports = __webpack_public_path__ + "img/hand-of-cards.22d230cf.png";